import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function ContactsIcon(props: IconProps) {
    return <Icon {...props} iconKey={"contacts"}/>
}
